import { useEffect, useState } from 'react'
import { commandPayload, commands } from '../../lib/runtime'
import { campaignSchema, type Campaign } from './promotionModel'

export const useCampaigns = (chefProfileId: string | undefined) => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([])
  const [loading, setLoading] = useState(true)
  const [loaded, setLoaded] = useState(false)
  const [loadError, setLoadError] = useState('')
  const [offset, setOffset] = useState(0)
  const [attempt, setAttempt] = useState(0)
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 30000)
    return () => window.clearInterval(timer)
  }, [])
  useEffect(() => {
    let active = true
    setLoading(true)
    setLoaded(false)
    setLoadError('')
    void commands.promotions.list(offset).then((response) => {
      const parsed = campaignSchema.array().parse(commandPayload(response).campaigns)
      if (active) { setCampaigns(parsed); setLoaded(true) }
    }).catch(() => { if (active) setLoadError('Could not load campaigns. Retry to see current status.') })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [offset, attempt, chefProfileId])

  return { campaigns, setCampaigns, loading, loaded, loadError, offset, setOffset, now, refresh: () => setAttempt((n) => n + 1) }
}
